export default __webpack_public_path__ + "758e2e9eda61994d92ff87384b2916cd.png";